const state = {
  isOffline: false,
};

const getters = {
  /**
   * Returns whether the user is offline
   */
  getIsOffline(state) {
    return state.isOffline;
  },
};

const actions = {
  /**
   * Set whether the user is offline
   */
  setIsOffline(context, { value }) {
    context.commit('setIsOffline', { value });
  },
};

const mutations = {
  /**
   * Set whether the user is offline
   */
  setIsOffline(state, { value }) {
    state.isOffline = value;
  },
};

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default module;
